import React, { FC, useCallback, ChangeEvent } from 'react';
import useMenuActions from 'data/hooks/useMenuActions';
import { statusOptions } from 'model/menu';
import { stopPropagation } from 'utils/onClickHelpers';

import { Select, Chip, Spinner } from './styles';
import { Props } from './types';

const Status: FC<Props> = ({
  mode,
  state,
  brandId,
  itemId,
  value,
  isUpdatingStatus,
  ...props
}) => {
  const { suspend, unsuspend, isLoading } = useMenuActions();

  const handleChange = useCallback(
    (
      event: ChangeEvent<{
        name?: string | undefined;
        value: unknown;
      }>,
    ) => {
      const newValue = event.target.value as typeof value;

      if (value === newValue) {
        return null;
      }
      if (newValue === 'ACTIVE') {
        unsuspend({ brandId, itemId });
      } else {
        suspend({ brandId, itemId, pauseType: newValue });
      }

      return null;
    },
    [brandId, itemId, value, suspend, unsuspend],
  );

  if (isUpdatingStatus) {
    return (
      <Chip $mode={mode}>
        <Spinner />
      </Chip>
    );
  }

  if (state === 'PROCESSING') {
    return (
      <Chip $mode={mode}>
        <div>Not available yet</div>
      </Chip>
    );
  }

  return (
    <Select
      $mode={mode}
      disabled={isLoading}
      value={value}
      onChange={handleChange}
      options={statusOptions}
      onClick={stopPropagation}
      {...props}
    />
  );
};

export default Status;

// TODO: TFR-29 add story to component
